export function priceFormatter(num) {
  const formatter = new Intl.NumberFormat('it-IT', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
  return formatter.format(num);
}
